module.exports = __webpack_public_path__ + "static/media/beesHalfScreen.f838071a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/beesHalfScreen.jpg
// module id = 145
// module chunks = 0